var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScatterPlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.3556V52.3556C0 52.3556 0.136317 53.3566 0.5 53.8556C0.914662 54.4246 2 54.8556 2 54.8556H53C53 54.8556 54.1923 54.1248 54.5 53.3556C54.7901 52.6304 54.7901 52.0808 54.5 51.3556C54.1923 50.5864 53 49.8556 53 49.8556H4.5V1.3556C4.5 1.3556 3.98278 0.623817 3.5 0.355604C2.64655 -0.118535 1.85345 -0.118535 1 0.355604C0.517216 0.623817 0 1.3556 0 1.3556Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.8555,
    r: 9,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.8555,
    r: 5,
    fill: "#005F60"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 11.8555,
    r: 9,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 11.8555,
    r: 5,
    fill: "#005F60"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 35.8555,
    r: 9,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 35.8555,
    r: 5,
    fill: "#005F60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterPlot);
export default __webpack_public_path__ + "static/media/scatter_plot.4cdbbd71d9f1aeab2689f0982b55550c.svg";
export { ForwardRef as ReactComponent };